/* ==========================================================================
   Accessibility runtime fixes — Megamaster
   --------------------------------------------------------------------------
   Loaded after theme.js. Only for problems that cannot be fixed in Liquid or
   CSS because the markup is produced by a library inside the compiled bundle.

   #4.1.2 — Flickity hero: aria-hidden slides keep their links tabbable
   --------------------------------------------------------------------------
   theme.js initialises Flickity with `cellSelector: '.banner'`. Flickity marks
   non-selected cells `aria-hidden="true"`, which is correct, but it does not
   remove their contents from the tab order. The result is that keyboard users
   tab into invisible slides and land on links they cannot see — axe reports it
   as "aria-hidden elements must not be focusable nor contain focusable
   elements", 3 instances on the homepage (SHOP NOW, the MyGrillParts link, and
   Get The Recipe).

   The Flickity options live in the compiled bundle with no source in this repo,
   so the fix cannot go there. Instead: watch aria-hidden on the cells and keep
   `inert` in sync. `inert` removes the subtree from the tab order AND from the
   accessibility tree, which is exactly the intent, and it changes nothing
   visually — so the carousel's animation and layout are untouched.

   Detected with axe DevTools on 2026-08-18.
   ========================================================================== */

(function () {
  'use strict';

  var CELL = '.banner';

  /* Older browsers without inert: fall back to tabindex bookkeeping so the
     links still leave the tab order. We store the previous value so a slide
     that legitimately had tabindex keeps it when it becomes active again. */
  var supportsInert = 'inert' in HTMLElement.prototype;
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex], iframe, area[href], summary';

  function sync(cell) {
    var hidden = cell.getAttribute('aria-hidden') === 'true';
    if (supportsInert) {
      if (cell.inert !== hidden) cell.inert = hidden;
      return;
    }
    var nodes = cell.querySelectorAll(FOCUSABLE);
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (hidden) {
        if (!n.hasAttribute('data-a11y-prev-tabindex')) {
          n.setAttribute('data-a11y-prev-tabindex', n.getAttribute('tabindex') === null ? '' : n.getAttribute('tabindex'));
        }
        n.setAttribute('tabindex', '-1');
      } else if (n.hasAttribute('data-a11y-prev-tabindex')) {
        var prev = n.getAttribute('data-a11y-prev-tabindex');
        if (prev === '') n.removeAttribute('tabindex');
        else n.setAttribute('tabindex', prev);
        n.removeAttribute('data-a11y-prev-tabindex');
      }
    }
  }

  function init() {
    var cells = document.querySelectorAll(CELL);
    if (!cells.length) return;

    for (var i = 0; i < cells.length; i++) sync(cells[i]);

    /* Flickity rewrites aria-hidden on every slide change. Observing the
       attribute is more robust than hooking a library API we cannot see. */
    if (typeof MutationObserver !== 'function') return;
    var obs = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t.nodeType === 1 && t.matches && t.matches(CELL)) sync(t);
      }
    });
    for (var j = 0; j < cells.length; j++) {
      obs.observe(cells[j], { attributes: true, attributeFilter: ['aria-hidden'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Flickity initialises on window load in this theme; re-run so the initial
     state is correct even if the cells were not present at DOMContentLoaded. */
  window.addEventListener('load', init);
})();
